import React from 'react';
import SMCModal from '../../components/core/SMCModal';
import SMCModalBody from '../../components/core/SMCModal/SMCModalBody'
import {useTranslation} from 'react-i18next';
import SMCModalButtonContainer from '../../components/core/SMCModal/SMCModalButtonContainer';
import SMCButton from '../../components/Simple/SMCButton';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import SMCLabel from "../../components/Simple/SMCLabel";
import SMCLink from "../../components/Simple/SMCLink";


function NewDomainRequestModal({
                                   isOpen = false,
                                   onRequestClose,
                               }) {
    const {t} = useTranslation();

    // On each new open, reset values


    return (
        <SMCModal
            isOpen={isOpen}
            width={510}
            height={330}
            title={t('SMC_NEW_DOMAIN_REQUEST_TITLE')}
            onRequestClose={onRequestClose}
        >
            <SMCModalBody labelWidth={250}>
                <div style={{display: 'flex'}}>
                    <SMCLabel style={{fontSize: '1rem'}}>
                        Spark Management (SMP) is now Available in
                    </SMCLabel>
                    <SMCLink style={{fontSize: '1rem'}}
                             href={"https://portal.checkpoint.com/dashboard/sparkmanagement"}>
                        &nbsp;Infinity Portal
                    </SMCLink>
                    <SMCLabel style={{fontSize: '1rem'}}>.
                    </SMCLabel>
                </div>

                <div style={{display: 'flex'}}>
                    <SMCLabel style={{display: 'inline-block !important', paddingRight: 5, fontSize: '1rem'}}>For more
                        information refer to</SMCLabel>

                    <SMCLink style={{display: 'inline-block !important', fontSize: '1rem'}}
                             href={"https://supportcenter.checkpoint.com/supportcenter/portal?eventSubmit_doGoviewsolutiondetails=&solutionid=sk180467"}>
                        sk180467
                    </SMCLink>
                </div>
            </SMCModalBody>
            <SMCModalButtonContainer>
                <SMCButton onClick={onRequestClose}>
                    <FontAwesomeIcon style={{marginTop: '3px', marginRight: '5px'}} color="green"/>
                    {"Close"}
                </SMCButton>
            </SMCModalButtonContainer>
        </SMCModal>

    );
}

export default NewDomainRequestModal;